import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { availabilityQueries } from "@/domain/availability/availability.query";
import { CalendarAvailability } from "./-components/CalendarAvailability";

export const Route = createFileRoute("/dashboard/chef/disponibilites")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(
      availabilityQueries.myAvailabilities(format(new Date(), "yyyy-MM-dd")),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen ">
      <div className="container mx-auto  sm:px-6 py-4 sm:py-6 max-w-7xl">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
            Mes Disponibilités
          </h1>
          <p className="text-sm sm:text-base text-gray-600">
            Gérez vos créneaux de disponibilité en sélectionnant les périodes
            matin et soir pour chaque jour.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-6">
          <CalendarAvailability />
        </div>
      </div>
    </div>
  );
}
